import { Button } from "@/shared/components";
import { RowData, Table } from "@tanstack/react-table";
import type { DataTableFeatures } from "./data-table-features";

type DataTablePaginationProps<TData extends RowData> = {
    table: Table<DataTableFeatures, TData>;
};

function DataTablePagination<TData extends RowData>({ table }: Readonly<DataTablePaginationProps<TData>>) {
    const filteredRowCount = table.getFilteredRowModel().rows.length;
    const { pageIndex, pageSize } = table.store.state.pagination;
    const firstRow = filteredRowCount === 0 ? 0 : pageIndex * pageSize + 1;
    const lastRow = Math.min((pageIndex + 1) * pageSize, filteredRowCount);

    return (
        <div className="flex items-center justify-end space-x-2 py-4">
            <div className="text-muted text-s flex-1">
                Rijen {firstRow}-{lastRow} van {filteredRowCount}
            </div>
            <div className="space-x-2">
                <Button variant="tertiary" size="s" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                    Vorige
                </Button>
                <Button variant="tertiary" size="s" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                    Volgende
                </Button>
            </div>
        </div>
    );
}

export default DataTablePagination;
